import { render, staticRenderFns } from "./pendingDigitalResources.vue?vue&type=template&id=623c39b8&"
import script from "./pendingDigitalResources.vue?vue&type=script&lang=js&"
export * from "./pendingDigitalResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports